import CatalogTileCard from "../../../common/catalog/CatalogTileCard";
import { resolveCatalogInstructor } from "../../../common/catalog/catalogInstructorDisplay";

export default function Episode({ episode }) {
	const instructor = resolveCatalogInstructor(episode?.workshop_detail);
	const session = episode?.episode_number;
	const topRightBadge =
		session != null && session !== "" ? `جلسه ${session}` : undefined;

	return (
		<CatalogTileCard
			to={`/workshop_detail/${episode.workshop_id}/`}
			title={episode?.title ?? ""}
			imageUrl={episode?.image_url}
			actionLabel="مشاهده کارگاه"
			instructorItem={episode?.workshop_detail}
			subtitleMuted={instructor.isEmpty}
			topRightBadge={topRightBadge}
		/>
	);
}
